import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUsersList } from "../action/UserAction";

export default function Users() {
  const dispatch = useDispatch();
  const { loading, error, usersRecord } = useSelector(
    (s) => s.usersList
  );

  const getUsers = () => {
    dispatch(getUsersList());
  };

  useEffect(() => {
    if (!usersRecord) {
        getUsers();
    }
  }, [dispatch, usersRecord]);

  return usersRecord ? usersRecord.map(rec=>(
    <option key={rec.Id} value={rec.Id}>{rec.Name}</option>
  )) : (
    <option value="">No Record Exist!</option>
  );
}
